module.exports = __webpack_public_path__ + "static/img/user.29479ba0.png";